
<div [formGroup]="formGroup">
  <div *ngIf="label"
    class="mb-2">
    <yc-form-label
      [srOnly]="srOnlyLabel"
      [name]="'term'"
      [label]="label">
    </yc-form-label>
  </div>
  <yc-typeahead
    name="term"
    [attr.role]="'search'"
    [clearOnBlur]="clearOnBlur"
    [getDisplay]="getDisplay"
    [fetchData]="debounce.exec"
    [label]="'common:lblApplicant' | ycI18n: 'Applicant'"
    [maxResults]="1000"
    [scrollResults]="true"
    [srOnlyLabel]="true"
    [placeholder]="placeholder || ''"
    [showNoResults]="showNoResults"
    (onNoResults)="onNoResults.emit($event)"
    (onTermChange)="onTermChange.emit($event)"
    (onChange)="applicantSelected($event)">
    <ng-container *ycTypeaheadTemplate="let item = item;">
      <div class="d-flex flex-row" #row>
        <div class="p-2">
          <yc-user-initials-block
            [initials]="item.firstName[0] + item.lastName[0]"
            [backgroundColor]="isManager ?
              clientBranding.brandPrimary || '#0974a1' :
              '#0974a1'">
          </yc-user-initials-block>
        </div>
        <div class="mr-auto ps-2 pt-2"
          [attr.aria-label]="'common:textApplicantInformation' | ycI18n: 'Applicant Information'">
          <ng-container>
            <div class="name-wrap"
              [attr.aria-label]="item.firstName + '' + item.lastName">
              {{ item.firstName }} {{ item.lastName }}
            </div>
          </ng-container>
          <small *ngIf="showEmailAddress"
            class="d-block"
            [attr.aria-role]="'contentinfo'"
            [attr.aria-label]="'common:textApplicantEmailDynamic' | ycI18n: 'Applicant email is __email__' : { email: item.email}">
            {{ item.email }}
          </small>
          <small class="d-block"
            [attr.aria-role]="'contentinfo'"
            [attr.aria-label]="'common:textApplicantPhoneNumberDynamic' | ycI18n: 'Applicant phone number is __phoneNumber__' : { phoneNumber: item.phoneNumber }">
            {{ item.phoneNumber  }}
          </small>
        </div>
      </div>
    </ng-container>
  </yc-typeahead>
</div>
